// extracted by mini-css-extract-plugin
export default {"userInfoTable":"UserInfoTable_userInfoTable__uthXg"};